import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { makeFetchRequest } from '../utils'
dayjs.extend(advancedFormat);
dayjs.extend(utc)

const { VUE_APP_GATEWAY_HOST } = process.env;
import { EventBus } from '../mixins'


Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths: ['contextInfo', 'query', 'filters', 'activeBrand', 'guidesToSet']
  })],
  state: {
    user: null,
    contextInfo: {
      partner: 1,
      sales_type: 1,
      allotement: 1,
      fata_id: 0,
      rese_id: 0,
      context_action: "formcreate"
    },
    dataRemove: null,
    canWrite: false,
    query: "*",
    filters: [],
    loader: false,
    loading: false,
    activeBrand: 'ucpa',
    resetSearchInsideEachFacet: false,
    guidesToSet: []
  },
  getters: {
    getActiveBrand (state) {
        return state.activeBrand
    },
    allowAction: (state) => (contentRoles) => {
      const userRoles = state.user.roles || null
      if(!userRoles) return false

      if(userRoles.includes('admin')) return true

      let isAllowed = false
      contentRoles.map(contentRole => {
        if(userRoles.includes(contentRole)) isAllowed = true
      })

      return isAllowed
    },
    allowField: (state) => (contentHideField) => {

      let isAllowed = true;

      const filterFounded = state.filters.find(filter => filter.field === contentHideField.fieldName);

      if (filterFounded && contentHideField.values.includes(filterFounded.value)) {
        isAllowed = false;
      }

      return isAllowed
    }
  },
  actions: {
    async setGuide( { commit, state } , { date, iresaCode, guides, removeAction}) {
    
      const dateString = dayjs.utc(parseInt(date)).format("DD-MM-YYYY");

      const body = {
        query: `mutation iresaSetGuides($packageCode: Int!, $date: String!, $guides: [IresaGuideInput]!, $idPartner: Int!, $marque: Int!, $removeAction: Boolean) { 
          iresaSetGuides (packageCode: $packageCode, date: $date , guides: $guides, idPartner: $idPartner, marque: $marque, removeAction: $removeAction) { 
            success message data 
          }
        }`,
        variables: {
          packageCode: parseInt(iresaCode),
          date: dateString,
          guides: guides,
          idPartner: state.contextInfo.partner,
          marque: state.contextInfo.rese_id,
          removeAction: removeAction
        }
      }

      const notification = {
        type: 'success'
      };

      // Mutation to save min depart guarantee
      await makeFetchRequest(VUE_APP_GATEWAY_HOST, 'POST', body).then(() => {
        notification.message = "Accompagnateur enregistrée";
      }).catch(err => {
        console.log("ERR: ", err)
        notification.type = "danger";
        notification.message = "Une erreur s'est produite";
      });

      commit('setRemoveData', true)
      EventBus.$emit('show-notifications', [notification]);
    },
    async setSellState({ commit, state }, { iresaCode, dateDepart, status }) {
      const dateDepartString = dayjs.utc(parseInt(dateDepart)).format("DD-MM-YYYY");

      const body = {
        query: `mutation iresaSetStatus($packageCode: Int!, $date: String!, $status: String!, $idPartner: Int!, $marque: Int!) {
          iresaSetStatus(packageCode: $packageCode, date: $date , status: $status, idPartner: $idPartner, marque: $marque) {
            success
            message
            data
          }
        }`,
        variables: {
          packageCode: parseInt(iresaCode),
          date: dateDepartString,
          status: status,
          idPartner: state.contextInfo.partner,
          marque: state.contextInfo.rese_id
        }
      }

      const notification = {
        type: 'success'
      };

      await makeFetchRequest(VUE_APP_GATEWAY_HOST, 'POST', body).then((res) => {
        if (!res.data.data.iresaSetStatus) throw new Error(JSON.stringify(res.data.errors, null, 2));

        notification.message = "Status enregistrée";
      }).catch(err => {
        console.log("ERR: ", err)
        notification.type = "danger";
        notification.message = "Une erreur s'est produite";
      });

      commit('setRemoveData', true)

      return notification;
    },
    async iresaStopSale({ commit, state }, { iresaCode, dateDepart, dateRetourn, guidStopVent, status, isCancelation }) {
      const dateDepartString = dayjs.utc(parseInt(dateDepart)).format("DD-MM-YYYY");
      const dateRetournString = dayjs.utc(parseInt(dateRetourn)).format("DD-MM-YYYY");

      const body = {
        query: `mutation iresaStopSale($packageCode: Int!, $dateDepart: String!, $dateRetourn: String!, $guidStopVent: String, $status: String!, $isCancelation: Boolean, $idPartner: Int!, $marque: Int!) {
          iresaStopSale(packageCode: $packageCode, dateDepart: $dateDepart, dateRetourn: $dateRetourn, guidStopVent: $guidStopVent, status: $status, isCancelation: $isCancelation, idPartner: $idPartner, marque: $marque) {
            success
            message
            data
          }
        }`,
        variables: {
          packageCode: parseInt(iresaCode),
          dateDepart: dateDepartString,
          dateRetourn: dateRetournString,
          guidStopVent: guidStopVent,
          status: status,
          isCancelation: isCancelation,
          idPartner: state.contextInfo.partner,
          marque: state.contextInfo.rese_id
        }
      }

      const notification = {
        type: 'success'
      };

      await makeFetchRequest(VUE_APP_GATEWAY_HOST, 'POST', body).then((res) => {
        const { success, data } = res.data.data.iresaStopSale;

        if (!success) throw new Error(JSON.stringify(res.data.errors, null, 2));

        notification.message = "Status enregistrée";
        notification.data = data;
      }).catch(err => {
        console.log("ERR: ", err)
        notification.type = "danger";
        notification.message = "Une erreur s'est produite";
      });

      commit('setRemoveData', true)

      return notification;
    }
  },
  mutations: {
    setRemoveData(state, data) {
      Vue.set(state, 'dataRemove', data)
    },
    setActiveBrand (state, data) {
      Vue.set(state, 'activeBrand', data)
    },
    setUser(state, data) {
      Vue.set(state, 'user', data)
    },
    setCanWrite(state, data){
      Vue.set(state, 'canWrite', data)
    },
    setContextInfo(state, data) {
      Vue.set(state, 'contextInfo', data)
    },
    setQuery(state, data) {
      Vue.set(state, 'query', data)
    },
    setGuides(state, data) {
      Vue.set(state, 'guidesToSet', data)
    },
    setFilter(state, data) {
      state.filters.push(data)
    },
    removeFilter(state, data) {
      const index = state.filters.findIndex(filter => filter.id === data.id);
      if (index !== -1) state.filters.splice(index, 1);
    },
    removeFilterType(state, data) {
      const index = state.filters.findIndex(filter => filter.field === data.field)
      state.filters.splice(index, 1);
    },
    resetFilter(state) {
      Vue.set(state, 'filters', [])
    },
    setLoader(state, data) {
      Vue.set(state, 'loader', data)
    },
    setResetSearchInsideEachFacet(state, data) {
      Vue.set(state, 'resetSearchInsideEachFacet', data)
    }
  }
})

export default store;